<template>
  <b-modal
    id="import-issues-modal"
    title="Import requirements from CSV"
    name="import-issues-modal"
    ref="importissuesmodal"
    size="lg"
    :busy="loading"
    ok-title="Import"
    close-title="Cancel"
    hide-header-close
    :ok-disabled="!uuidFileName || !requirementType"
    @ok="handleOk"
    @cancel="handleCancel"
    @shown="shown">
    <div class="form-group">
      <b-form-group description="These types can be managed on the rmCloud Configuration screen">
        <multiselect v-model="requirementType"
                     :options="requirementTypes"
                     :loading="requirementTypesLoading"
                     :allow-empty="false"
                     :close-on-select="true"
                     :hide-selected="false"
                     placeholder="Select a requirement type to import these requirements as"
                     label="name"
                     track-by="requirement_type_id">
        </multiselect>
      </b-form-group>
    </div>
    <div class="form-check">
      <label class="form-check-label">
        <input v-model="specificLocation" type="checkbox" class="form-check-input">
        Import to a specific location
      </label>
    </div>
    <folders-list v-if="specificLocation" :folders="folders"></folders-list>
    <!--TODO - only show this checkbox if Components column header is found -->
<!--    <div class="form-check">-->
<!--      <label class="form-check-label">-->
<!--        <input v-model="assignBasedOnComponent" type="checkbox" class="form-check-input">-->
<!--        Auto-assign requirements based on Jira Component defaults <icon id="assign-help-icon" name="info-circle"></icon>-->
<!--      </label>-->
<!--      <b-popover target="assign-help-icon"-->
<!--                 triggers="hover"-->
<!--                 content="If a component is specified for a given requirement to import, this will attempt to automatically assign the requirement to the default assignee of that component.">-->
<!--      </b-popover>-->
<!--    </div>-->
    <input type="file" @change="processFile($event)" id="file_input" ref="fileInput"/><icon v-if="uuidFileName" name="check" style="color: green; margin-left: 5px;"></icon><icon v-if="error" name="exclamation-circle" style="color: red; margin-left: 5px;"></icon>
    <p v-if="error" style="font-weight: bold;">{{ error }}</p>
<!--    <div class="form-group" v-if="headers.length > 0">-->
<!--      <multiselect v-model="selectedHeaders"-->
<!--                   :options="headers"-->
<!--                   :multiple="true"-->
<!--                   :close-on-select="true"-->
<!--                   :clear-on-select="false"-->
<!--                   :hide-selected="true"-->
<!--                   :max="30"-->
<!--                   placeholder="Additional field(s) to import"-->
<!--                   label="name"-->
<!--                   track-by="index">-->
<!--      </multiselect>-->
<!--    </div>-->
    <p>Required column names: <strong>Name</strong></p>
    <p>Optional column names: <strong>ID</strong>, <strong>Description</strong>, <strong>Component/s</strong>, <strong>Status</strong></p>
    <p>You can also use the names of any of your custom attributes</p>
    <div slot="modal-ok" v-if="loading">
      <icon name="spinner" pulse></icon> Importing
    </div>
  </b-modal>
</template>

<script>
  import dialogMixin from '@/mixins/dialog'
  import uploadToS3Mixin from '@/mixins/uploadToS3'
  import Papa from 'papaparse'
  import FoldersList from '@/components/FoldersList'
  import utilsMixin from '@/mixins/utils'
  export default {
    components: { FoldersList },
    computed: {
      selectedFolder () {
        return this.$store.state.selectedFolder
      }
    },
    data () {
      return {
        assignBasedOnComponent: false,
        atlassianComponentJson: [],
        atlassianStatusesJson: [],
        folders: [],
        headers: [],
        loading: false,
        selectedHeaders: [],
        specificLocation: false,
        requirementType: null,
        requirementTypesLoading: false,
        requirementTypes: []
      }
    },
    props: {
      currentProject: Object
    },
    mixins: [dialogMixin, uploadToS3Mixin, utilsMixin],
    methods: {
      clearModal () {
        this.assignBasedOnComponent = false
        this.error = ''
        this.headers = []
        this.loading = false
        this.selectedHeaders = []
        this.requirementType = null
        this.specificLocation = false
        this.uuidFileName = ''
        this.$refs.fileInput.value = null
        this.$store.commit('setSelectedFolder', null)
        this.requirementTypesLoading = false
        this.requirementTypes = []
      },
      handleOk (e) {
        e.preventDefault()
        this.loading = true
        this.importIssuesToRmcloudServer()
      },
      handleCancel (e) {
        this.clearModal()
      },
      shown () {
        this.getRequirementTypes()
        this.getAtlassianComponentJson()
        this.getAtlassianStatusesJson()
        this.getPrimaryFolders()
      },
      getPrimaryFolders () {
        this.$http.get(
          `/api/folder/primary?atlassian_project_id=${this.currentProject.id}`,
        ).then(response => {
          this.folders = response.data.folders
        }, response => {
          console.log('error')
        })
      },
      importIssuesToRmcloudServer () {
        if (this.uuidFileName) {
          let importLocation = this.specificLocation ? this.selectedFolder.folder_id : null
          this.$ga.event('requirement', 'import', importLocation, 1)
          this.$http.post(
            '/api/import-issues',
            {
              assign_based_on_component: this.assignBasedOnComponent,
              atlassian_component_json: this.atlassianComponentJson,
              atlassian_statuses_json: this.atlassianStatusesJson,
              atlassian_project_id: this.currentProject.id,
              file_name: this.uuidFileName,
              location: importLocation,
              requirement_type: this.requirementType,
              additional_headers: this.selectedHeaders
            }
          ).then(response => {
            window.AP.flag.create({
              title: 'Success!',
              body: 'Requirements imported successfully',
              type: 'success',
              close: 'auto'
            })
            this.clearModal()
            this.setTheState()
            this.$refs.importissuesmodal.hide()
          }, error => {
            let errorString = this.createErrorStringFromResponse(error.response.data)
            window.AP.flag.create({
              title: 'Error',
              body: `There was a problem importing your requirements: ${errorString}`,
              type: 'error'
            })
            this.loading = false
          })
        }
      },
      getSignedRequest (file) {
        // Check if the file.type is empty (can happen sometimes, see https://stackoverflow.com/questions/51724649/mime-type-of-file-returning-empty-in-javascript-on-some-machines)
        // It's 100% based on the filename anyway, so I can just hardcode text/csv if needed.
        let fileType = file.type
        if (fileType.length === 0) {
          if (file.name && file.name.endsWith('.csv')) {
            fileType = 'text/csv'
          }
        }
        this.$http.post(
          '/api/sign-s3-put',
          {
            operation: 'import',
            original_file_name: file.name,
            file_type: fileType
          }
        ).then(response => {
          this.error = ''
          this.uploadFile(file, fileType, response.data.presigned_url, response.data.uuid_file_name)
        }, response => {
          this.error = 'Error getting signed url.  Did you upload a .csv?'
        })
      },
      getAtlassianComponentJson () {
        window.AP.request({
          url: `/rest/api/3/project/${this.currentProject.id}/components`,
          success: response => {
            // convert the string response to JSON
            response = JSON.parse(response)

            this.atlassianComponentJson = response
          },
          error: () => {
            console.log(arguments)
          }
        })
      },
      getAtlassianStatusesJson () {
        window.AP.request({
          url: `/rest/api/3/project/${this.currentProject.id}/statuses`,
          success: response => {
            // convert the string response to JSON
            response = JSON.parse(response)

            this.atlassianStatusesJson = response
          },
          error: () => {
            console.log(arguments)
          }
        })
      },
      getRequirementTypes () {
        this.requirementTypesLoading = true
        this.$http.get(
          '/api/requirement/type'
        ).then(response => {
          this.requirementTypes = response.data.requirement_types
          this.requirementTypesLoading = false
        }, response => {
          this.requirementTypesLoading = false
          window.AP.flag.create({
            title: 'Error',
            body: 'There was a problem loading requirement type data from rmCloud.  Please contact rmCloud support via the "Get help" button',
            type: 'error'
          })
        })
      },
      processFile (event) {
        let file = event.target.files[0]
        Papa.parse(file, {
          header: true,
          complete: results => {
            const excludeHeaders = ['Summary', 'Description', 'Issue key', 'Component/s', 'Status', 'Name', 'ID']
            this.headers = results.meta.fields.map((h, index) => { return { index: index, name: h } }).filter(h => !excludeHeaders.includes(h.name))
          }
        })
        if (!file) {
          return alert('No file selected.')
        }
        this.getSignedRequest(file)
      },
      setTheState () {
        this.$store.commit('setNeedToRefreshItemsList', true)
      }
    }
  }
</script>

<style>
  #file_input {
    padding: 15px 0 15px 0;
  }
</style>



// WEBPACK FOOTER //
// ImportIssuesModal.vue?1a7cebeb